module.exports = __webpack_public_path__ + "img/msr.e147bd2b.svg";